import React from 'react';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers';

import { Dayjs } from 'dayjs';

interface LocalisedDatePickerProps {
  views?: Array<'year' | 'month' | 'day'>;
  label: string;
  date: Dayjs | null;
  setDate: (date: Dayjs | null) => void;
}

const LocalisedDatePicker: React.FC<LocalisedDatePickerProps> = ({
  views,
  label,
  date,
  setDate,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en'}>
      <DatePicker
        views={views}
        label={label}
        value={date}
        format={'DD/MM/YYYY'}
        onChange={(newValue) => setDate(newValue)}
        slotProps={{ textField: { size: 'small' } }}
      />
    </LocalizationProvider>
  );
};

export default LocalisedDatePicker;
